import React from "react";
import Privacy from "../Privacy";

function UserDeletion() {
  return (
    <Privacy>
      <div className="w-full text-[#475467] ">
        <h1 className="text-[28px] text-black pt-4 font-bold ">
          User Data Deletion Policy
        </h1>
        <p className="pt-4" id="OUR SERVICES">
          <span className="font-semibold "> Effective Date:</span> Jan 21st, 2024.
        </p>
        <p className="" id="OUR SERVICES">
          <span className="font-semibold "> Last Reviewed:</span> Jan 21st, 2024.
        </p>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            1. Purpose and Commitment
          </h1>
          <p>
            At <span className="font-bold">Arad</span>, we prioritize user privacy and data protection as core components of our platform. As a provider of a community-driven incident and alert-sharing service, we recognize our obligation to allow users to request the deletion of their personal data in accordance with global privacy standards and applicable data protection laws.
          </p>
          <p className="py-8">
            This <span className="font-bold">User Data Deletion Policy</span> ("Policy") outlines the circumstances, procedures, limitations, and effects related to the erasure of personal data collected by Arad, in alignment with our obligations under the:
          </p>
          <ul className="list-disc ml-10">
            <li className="font-bold py-2">General Data Protection Regulation (GDPR – EU/UK)</li>
            <li className="font-bold py-2">California Consumer Privacy Act (CCPA) and CPRA (USA)</li>
            <li className="font-bold py-2">Nigeria Data Protection Regulation (NDPR)</li>
            <li className="py-2">Other applicable international, federal, and state privacy laws</li>
          </ul>
        </div>

        <div className="my-6">

          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            2. Scope of the Policy
          </h1>
          <p>
            This policy applies to:
          </p>
          <ul className="list-disc ml-10">
            <li className="py-2">All registered users of the Arad platform (mobile and web-based)</li>
            <li className="py-2">Data subjects who have provided personal information through user interactions, incident reporting, notifications, or alerts</li>
            <li className="py-2">Former users who previously maintained an account with Arad</li>
            <li className="py-2">Representatives acting on behalf of verified data subjects</li>
          </ul>
        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            3. Categories of Data Eligible for Deletion
          </h1>
          <p>
            Upon a valid and verifiable request, Arad will delete the following categories of personal data, unless legally exempt:
          </p>
          <ul className="list-disc ml-10">
            <li className="py-2"><span className="font-bold">Account Information:</span> Full name, username, email, phone number, and associated identifiers</li>
            <li className="py-2"><span className="font-bold">User-Generated Content:</span> Incident reports, posts, comments, alerts, uploaded media (images, audio, video), if directly linked to the user's identity</li>
            <li className="py-2"><span className="font-bold">Location Data:</span> GPS, IP-based geolocation data, and usage patterns associated with location tracking</li>
            <li className="py-2"><span className="font-bold">Technical Identifiers:</span> Device ID, session tokens, advertising identifiers, and cookies</li>
            <li className="py-2"><span className="font-bold">Communications:</span> In-app messages, customer service interactions, chat history
            </li>
            <li className="py-2"><span className="font-bold">Behavioral and Analytics Data:</span> Engagement metrics, user preferences, usage logs
            </li>
          </ul>
        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            4. Data Not Subject to Deletion
          </h1>
          <p>
            Certain data may be retained despite a deletion request under legal, contractual, or operational grounds, including:
          </p>
          <ul className="list-disc ml-10">
            <li className="py-2"><span className="font-bold">Legal Compliance:</span> Data required to comply with law enforcement requests, court orders, government regulations, or statutory data retention obligations (e.g., fraud prevention, tax law, safety investigations).</li>
            <li className="py-2"><span className="font-bold">Contractual Obligations:</span> Data tied to active service contracts or unresolved financial or legal disputes.</li>
            <li className="py-2"><span className="font-bold">Security and Abuse Prevention:</span> Data necessary to detect, investigate, or prevent malicious activity or violations of platform policies.</li>
            <li className="py-2"><span className="font-bold">Platform Integrity:</span> Contributions to public safety data, historical reports, or anonymized datasets that no longer identify the user.</li>
            <li className="py-2"><span className="font-bold">Backup Systems:</span> Information stored in encrypted system backups will be retained temporarily (up to 90 days) before secure deletion, as part of disaster recovery protocol.
            </li>
          </ul>
        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            5. How to Request Deletion of Personal Data
          </h1>
          <p>
            Users may request data deletion through any of the following authorized methods:
          </p>
          <p className="font-semibold py-4" id="OUR SERVICES">
            a. In-App Request
          </p>
          <p>
            Navigate to:
          </p>
          <p className="font-semibold py-4" id="OUR SERVICES">
            Settings &gt; Account &gt; Request Account Deletion
          </p>
          <p className="font-semibold py-4" id="OUR SERVICES">
            b. Email Submission
          </p>
          <p>
            Send a formal request to:
          </p>
          <p className="font-semibold py-4" id="OUR SERVICES">
            privacy@myaradugbo.com
          </p>
          <p className="pb-4">
            <span className="font-bold">Subject Line:</span> "User Data Deletion Request"
          </p>
          <p>
            Please include the following:
          </p>
          <ul className="list-disc ml-10">
            <li className="py-2">Full legal name</li>
            <li className="py-2">Registered email address or phone number used with the account</li>
            <li className="py-2">Username (if known)</li>
            <li className="py-2">A clear statement requesting deletion of all associated personal data</li>
            <li className="py-2">If acting on behalf of another individual: documented proof of legal authority (e.g., Power of Attorney, parental/guardian consent)
            </li>
          </ul>
        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            6. Identity Verification Process
          </h1>
          <p>
            To protect user data and prevent unauthorized access or malicious deletion:
          </p>
          <ul className="list-disc ml-10">
            <li className="py-2">We may request additional information or documentation to confirm your identity</li>
            <li className="py-2">In the case of sensitive or high-risk requests, we reserve the right to perform multi-factor verification</li>
            <li className="py-2">If identity cannot be confirmed within 30 days, we may deny the request and notify the requester with the reason</li>
          </ul>
        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            7. Response Timeline
          </h1>
          <p className="mb-4">
            Arad endeavors to respond to verifiable deletion requests as follows:
          </p>
          <table className="border text-left w-4/5">
            <tr className="border p-2">
              <th className="p-2">Jurisdiction</th>
              <th>Acknowledgment</th>
              <th>Completion Time</th>
            </tr>
            <tr className="border p-2">
              <td className="p-2">EU/UK (GDPR)</td>
              <td>Within 7 days</td>
              <td>Within 30 days (extendable to 60)</td>
            </tr>
            <tr className="border p-2">
              <td className="p-2">USA (CCPA/CPRA)</td>
              <td>Within 10 business days</td>
              <td>Within 45 calendar days</td>
            </tr>
            <tr className="border p-2">
              <td className="p-2">Nigeria (NDPR)</td>
              <td>Within 7 business days</td>
              <td>Within 30 calendar days</td>
            </tr>
          </table>
          <p>
            Extensions may be applied in complex cases with notice to the data subject.
          </p>
        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            8. Impact of Deletion
          </h1>
          <p className="mb-4">
            If a deletion request is honored:
          </p>
          <ul className="list-disc ml-10">
            <li className="py-2"><span className="font-bold">User Account Termination: </span>Your account will be permanently closed and rendered inactive.</li>
            <li className="py-2"><span className="font-bold">Data Erasure: </span>All personal identifiers will be purged from our active systems, subject to exceptions above.</li>
            <li className="py-2"><span className="font-bold">Loss of Access: </span>You will no longer have access to your account, any data, historical contributions, or alerts.</li>
            <li className="py-2"><span className="font-bold">Platform Integrity: </span>Contributions to public safety data, historical reports, or anonymized datasets that no longer identify the user.</li>
            <li className="py-2"><span className="font-bold">Irreversibility: </span>Once deletion is complete, the action cannot be undone.
            </li>
          </ul>
        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            9. Anonymized and Aggregated Data
          </h1>
          <p className="mb-4">
            Data that has been anonymized in such a way that you are no longer identifiable is excluded from deletion obligations. We may retain such anonymized or aggregated data indefinitely for statistical, analytical, or research purposes, provided no individual can be re-identified.
          </p>

        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            10. Appeals and Denials
          </h1>
          <p className="mb-4">
            If your deletion request is denied, you will receive a written explanation, including:
          </p>
          <ul className="list-disc ml-10">
            <li className="py-2">Legal or operational reasons for denial
            </li>
            <li className="py-2">Any applicable dispute resolution channels</li>
            <li className="py-2">Instructions on how to re-submit a corrected or verified request
            </li>
          </ul>
          <p>You may also file a complaint with a relevant Data Protection Authority or regulatory agency.
          </p>
        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            11. Contact and Complaints
          </h1>
          <p>
            For any questions, deletion requests, or to file a complaint, please contact:
          </p>
          <p className="font-semibold  py-2" id="OUR SERVICES">
            Data Protection Officer (DPO)          </p>
          <p>
            Arad
          </p>
          <p className="pb-1">
            <span className="font-bold">Email:</span> privacy@myaradugbo.com
          </p>
          <p className="pb-1">
            <span className="font-bold">Phone:</span> (908) 900-1277
          </p>
          <p>
            <span className="font-bold">Mailing Address:</span>
          </p>
        </div>

        <div className="my-6">
          <h1 className=" text-[28px] py-4" id="OUR SERVICES">
            12. Updates to This Policy
          </h1>
          <p className="mb-4">
            We reserve the right to modify or update this User Data Deletion Policy at our discretion. Revisions will be made in response to legal, operational, or technical changes and will be communicated via in-app notifications or posted updates. Continued use of the Arad platform after such changes constitutes acknowledgment of the updated terms.
          </p>

        </div>
      </div>
    </Privacy>
  );
}

export default UserDeletion;
